export const baseUrl = {
    urlOnline: "http://www.qianchengjx.com/website",
}
export const clientInfo = {
    id: "qcjx",
    pass: "qcjx",
}
export function bgColorFn(...arr) {
    let color = arr[arr.length - 1];
    for (let i = 0; i < arr.length - 1; i++) {
        arr[i].style.backgroundColor = color;
    }
}
export function scrollHome(ratio, homeRef, videoRightDom, videoLeftDom) {
    switch (true) {
        case ratio >= 0.29:
            videoRightDom.style.width = "46%";
            videoRightDom.style.top = "10%";
            videoRightDom.style.right = "2%";
            videoLeftDom.style.width = "46%";
            videoLeftDom.style.top = "30%";
            videoLeftDom.style.left = "2%";
            return;
        case ratio >= 0.26:
            videoRightDom.style.width = "27%";
            videoRightDom.style.top = "23%";
            videoRightDom.style.right = "21.5%";
            videoLeftDom.style.width = "27%";
            videoLeftDom.style.top = "37%";
            videoLeftDom.style.left = "21.5%";
            return;
        case ratio >= 0.22:
            videoRightDom.style.width = "9%";
            videoRightDom.style.top = "35%";
            videoRightDom.style.right = "39.5%";
            videoLeftDom.style.width = "9%";
            videoLeftDom.style.top = "45%";
            videoLeftDom.style.left = "39.5%";
            return;
        case ratio >= 0.18:
            videoRightDom.style.width = "0%";
            videoRightDom.style.top = "52%";
            videoRightDom.style.right = "44%";
            videoLeftDom.style.width = "0%";
            videoLeftDom.style.top = "66%";
            videoLeftDom.style.left = "44%";
            return;
    }
}